import { Component, ElementRef, OnInit, OnChanges, SimpleChanges, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { combineLatest } from 'rxjs';
import { FormField } from '../../../../dto/util/form-field';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { Constants } from '../../../../constants/constants';
import { CrearEventoEntidadDto } from '../../../../dto/eventos/evento-entidad.dto';
import { EventosEntidadService } from '../../services/eventos-entidad.service';
import { AlertaModalService } from '../../../../services/util/alerta-modal.service';
import { ListasService } from '../../../../services/listas.service';

@Component({
  selector: 'app-modal-gestion-eventos-entidad',
  templateUrl: './modal-gestion-eventos-entidad.component.html',
  styleUrls: ['./modal-gestion-eventos-entidad.component.scss']
})

export class ModalGestionEventosEntidadComponent implements OnInit, OnChanges {
  @ViewChild('modalEventos') modalEventosAdd!: ElementRef;
  // Referencia al componente de formulario app-form
  @ViewChild('appFormComponent') appFormComponent!: any;
  fieldsModal: FormField[] = [];

  @Output() cargarListas = new EventEmitter<boolean>();
  @Input() eventosEliminar: CrearEventoEntidadDto[] = [];
  formEventoEntidad!: FormGroup;
  // Multilenguaje
  gestionEventoText: any = {};
  comunText: any = {};
  Id_Entidad: number = 0;
  isEditar: boolean = false;
  private eventoOriginal?: CrearEventoEntidadDto;
  constructor(
    private translate: TranslateService,
    private readonly fb: FormBuilder,
    private readonly eventosService: EventosEntidadService,
    private readonly alertaModalService: AlertaModalService,
    private readonly listaServices: ListasService
  ) {
    combineLatest({
      gestionEvento: this.translate.stream('gestion-evento-entidad'),
      comun: this.translate.stream('comun'),
    }).subscribe(({ gestionEvento, comun }) => {
      // Asignar traducciones a variables
      this.gestionEventoText = gestionEvento;
      this.comunText = comun;
      this.cargarFormularioModal();
    });
    this.formEventoEntidad = this.fb.group({
    });
  }

  ngOnInit(): void {
    this.Id_Entidad = JSON.parse(sessionStorage.getItem(Constants.USER_TYPE) || '{}').Id_Entidad;
    this.getExtencionesImagen();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['eventosEntidad']) {
    }
  }

  // Agregar y Editar eventos
  abrirModal(isEditar: boolean) {
    this.isEditar = isEditar;
    this.modalEventosAdd.nativeElement.click();
  }

  cancelar() {
    this.limpiarFormulario();
    this.modalEventosAdd.nativeElement.click();
  }

  cargarFormularioModal() {
    this.fieldsModal = [
      {
        name: 'imagen',
        label: this.gestionEventoText['imagen'],
        tooltip: this.gestionEventoText['formato-requerido'],
        type: 'image',
        required: true,
        placeholder: this.gestionEventoText['imagen-placeholder'],
        width: '12',
        visible: true,
        errorMessages: {
          required: this.gestionEventoText['imagen-required'],
        },
        imageExtensions: this.fieldsModal?.find(f => f.name === 'imagen')?.imageExtensions || [],
      },
      {
        name: 'nombreEvento',
        label: this.gestionEventoText['nombre-evento'],
        type: 'text',
        required: true,
        placeholder: this.gestionEventoText['nombre-evento'],
        width: '12',
        visible: true,
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_NOMBRE_EVENTO),
        ],
        errorMessages: {
          required: this.gestionEventoText['nombre-evento-required'],
          pattern: this.gestionEventoText['nombre-evento-pattern'],
          minlength: this.gestionEventoText['nombre-evento-minlength'],
          maxlength: this.gestionEventoText['nombre-evento-maxlength'],
        },
      },
      {
        name: 'descripcionEvento',
        label: this.gestionEventoText['descripcion-evento'],
        type: 'textarea',
        required: true,
        placeholder: this.gestionEventoText['descripcion-evento'],
        width: '12',
        visible: true,
        validation: [
          Validators.minLength(2),
          this.maxWordsValidator(25),
          Validators.pattern(Constants.REGEX_NOMBRE_EVENTO),
        ],
        noConvertToUpperCase: true,
        errorMessages: {
          required: this.gestionEventoText['descripcion-evento-required'],
          pattern: this.gestionEventoText['descripcion-evento-pattern'],
          minlength: this.gestionEventoText['descripcion-evento-minlength'],
          maxlength: this.gestionEventoText['descripcion-evento-maxlength'],
        },
      },
      {
        name: 'fechaEvento',
        label: this.gestionEventoText['fecha-evento'],
        type: 'datetime',
        required: true,
        width: '6',
        visible: true,
        errorMessages: {
          required: this.gestionEventoText['fecha-evento-required'],
        },
      },
      {
        name: 'linkDescripcion',
        label: this.gestionEventoText['link-inscripcion'],
        type: 'text',
        required: true,
        width: '6',
        visible: true,
        errorMessages: {
          required: this.gestionEventoText['link-inscripcion-required'],
        },
      },

    ];
  }

  getExtencionesImagen() {
    this.listaServices.getTipoAnexos(this.Id_Entidad).subscribe({
      next: (response) => {
        let anexos = response.find(anexo => anexo.Categoria == 'Evento');
        const estadosField = this.fieldsModal.find(field => field.name === 'imagen');
        if (estadosField) {
          estadosField.imageExtensions = Array.isArray(anexos?.Extensiones)
            ? anexos?.Extensiones
            : anexos?.Extensiones
              ? [anexos.Extensiones]
              : [];
          this.fieldsModal = [...this.fieldsModal];
        }
      },
    });
  }

  onSubmitFormulario(event: FormGroup): void {
    this.formEventoEntidad = event;
    if (this.formEventoEntidad) {
      if (!this.formEventoEntidad.get('imagen')?.value) {
        this.fieldsModal.forEach(field => {
          if (field.name === 'imagen') {
            field.value = undefined; // Limpiar el valor del campo imagen
          }
        });
      }
    }
  }

  onSubmitEvento($event: {
    controlName?: string;
    controlValue: unknown;
    form: FormGroup;
  }) {
    this.formEventoEntidad = $event.form;
  }

  abrirConDatos(evento: CrearEventoEntidadDto) {
    this.eventoOriginal = evento;
    this.formEventoEntidad.get('Id_Evento')?.setValue(evento.Id);
    this.fieldsModal = this.fieldsModal.map(field => {
      switch (field.name) {
        case 'imagen':
          field.value = evento.Imagen;
          break;
        case 'nombreEvento':
          field.value = evento.Nombre_Evento;
          break;
        case 'descripcionEvento':
          field.value = evento.Descripcion_Evento;
          break;
        case 'fechaEvento':
          const fechaUTC = new Date(evento.Hora); // viene con Z (UTC)

          // obtener hora local (Colombia UTC-5)
          const hours = String(fechaUTC.getHours()).padStart(2, '0'); // local time 👌
          const minutes = String(fechaUTC.getMinutes()).padStart(2, '0');

          field.value = evento.Fecha.split('T')[0] + `T${hours}:${minutes}`;
          break;
        case 'linkDescripcion':
          field.value = evento.Lugar;
          break;
      }
      return field;
    });
    this.abrirModal(true);
  }

  limpiarFormulario() {
    this.cargarFormularioModal();
    this.formEventoEntidad.reset();

    // Limpiar las imágenes previas en el componente de formulario
    if (this.appFormComponent) {
      this.appFormComponent.resetPreviewImages();
    }
  }

  confirmar() {
    // Lógica para confirmar la acción
    if (this.isEditar) {
      this.editarEvento();
    } else {
      this.crearEvento();
    }
  }

  private async crearFormData(evento: CrearEventoEntidadDto, file?: File): Promise<FormData> {
    const formData = new FormData();
    formData.append('evento', JSON.stringify(evento)); // DTO como JSON
    if (file) {
      formData.append('archivos', file); // imagen del evento
    }
    return formData;
  }

  crearEvento() {
    const evento: CrearEventoEntidadDto = {
      Nombre_Evento: this.formEventoEntidad.value.nombreEvento,
      Lugar: this.formEventoEntidad.value.linkDescripcion,
      Id_Entidad: this.Id_Entidad,
      Fecha: new Date(this.formEventoEntidad.value.fechaEvento).toISOString(),
      Hora: new Date(this.formEventoEntidad.value.fechaEvento).toISOString(),
      Descripcion_Evento: this.formEventoEntidad.value.descripcionEvento.toUpperCase(),
    };

    const file = this.formEventoEntidad.value.imagen as File;

    this.crearFormData(evento, file).then(formData => {
      this.eventosService.crearEventoEntidad(formData).subscribe({
        next: () => {
          this.alertaModalService.exito(
            this.gestionEventoText['modal']['exito'],
            this.gestionEventoText['modal']['exito-mensaje']
          );
          this.limpiarFormulario();
          this.abrirModal(false);
          this.cargarListas.emit(true);
        },
        error: (error) => {
          this.alertaModalService.error(
            this.gestionEventoText['modal']['error'],
            this.gestionEventoText['modal']['error-mensaje']
          );
          this.limpiarFormulario();
          this.abrirModal(false);
          this.cargarListas.emit(false);
        }
      });
    });
  }

  editarEvento() {
    const evento: CrearEventoEntidadDto = {
      Nombre_Evento: this.formEventoEntidad.value.nombreEvento,
      Lugar: this.formEventoEntidad.value.linkDescripcion,
      Id_Entidad: this.Id_Entidad,
      Fecha: new Date(this.formEventoEntidad.value.fechaEvento).toISOString(),
      Hora: new Date(this.formEventoEntidad.value.fechaEvento).toISOString(),
      Descripcion_Evento: this.formEventoEntidad.value.descripcionEvento.toUpperCase(),
    };

    const file = this.formEventoEntidad.value.imagen as File;

    this.crearFormData(evento, file).then(formData => {
      this.eventosService.actualizarEventoEntidad(formData,
        this.eventoOriginal?.Id!).subscribe({
          next: () => {
            this.alertaModalService.exito(
              this.gestionEventoText['modal']['exito'],
              this.gestionEventoText['modal']['exito-mensaje']
            );
            this.limpiarFormulario();
            this.abrirModal(false);
            this.cargarListas.emit(true);
          },
          error: (error) => {
            this.alertaModalService.error(
              this.gestionEventoText['modal']['error'],
              this.gestionEventoText['modal']['error-mensaje']
            );
            this.limpiarFormulario();
            this.abrirModal(false);
            this.cargarListas.emit(false);
          }
        });
    });
  }

  maxWordsValidator(maxWords: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) return null; // Si está vacío no hay error

      const wordCount = control.value.trim().split(/\s+/).length;
      return wordCount > maxWords
        ? { maxWords: { requiredWords: maxWords, actualWords: wordCount } }
        : null;
    };
  }

  // Método para eliminar un evento
  abrirModalBorrar() {
    this.alertaModalService.confirmacion(
      this.gestionEventoText['confirmar-eliminado'],
      this.gestionEventoText['eliminar-evento'],
      () => {
        this.eliminarEventos();
      },
      () => {
        this.alertaModalService.exito(this.gestionEventoText['accion_cancelada'])
      }, true)
    // this.modalEliminarEventos.nativeElement.click();
  }

  eliminarEventos() {
    const ids = this.eventosEliminar.map(evento => evento.Id!);
    // Lógica para eliminar el evento
    this.eventosService.eliminarEventoEntidad(ids).subscribe({
      next: () => {
        this.alertaModalService.exito(
          this.gestionEventoText['modal']['exito'],
          this.gestionEventoText['modal']['exito-mensaje']
        );
        this.cargarListas.emit(true);
      },
      error: (error) => {
        this.alertaModalService.error(
          this.gestionEventoText['modal']['error'],
          this.gestionEventoText['modal']['error-mensaje']
        );
        this.cargarListas.emit(false);
      }
    });
  }
}
